export const DEFAULT_FORMAT = 'MM/DD/YYYY @ h:mm a';
export const ABBR_DEFAULT_FORMAT = 'M/D/YY @ h:mm a';
export const PRETTY_FORMAT = 'll @ LT';
export const TIME_FORMAT = 'h:mma';
